import { ensureHash } from '@refinio/one.core/lib/util/type-checks.js';
import { CrdtAlgorithmStandard } from '@refinio/one.core/lib/crdts/interfaces/CrdtAlgorithmStandard.js';
import { linkedListMerge } from './merge.js';
export class LinkedListCrdtAlgorithm extends CrdtAlgorithmStandard {
    id = 'LinkedListCrdtAlgorithm';
    initialDiff(value) {
        const hash = ensureHash(value);
        return [{ op: 'set', value: hash }];
    }
    diff(value1, value2) {
        const hash1 = ensureHash(value1);
        const hash2 = ensureHash(value2);
        if (hash1 !== hash2) {
            return [{ op: 'set', value: hash2 }];
        }
        else {
            return [];
        }
    }
    async merge(tree) {
        const hash1 = ensureHash(tree.firstMergeNode.data);
        const hash2 = ensureHash(tree.secondMergeNode.data);
        return linkedListMerge(hash1, hash2);
    }
}
//# sourceMappingURL=LinkedListCrdtAlgorithm.js.map